<template>
  <div>
    <div class="clear"></div>
    <div class="f_bg1">
      <div class="footer">
        <h2>
              <router-link tag="a" :to="{name: 'home',params: { id: 1,nid:1 }}">
                <span>首页</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'product', params: { id: 59,nid:2 }}">
                <span>管焊机</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'product', params: { id: 62,nid:3 }}">
                <span>管板焊机</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'product', params: { id: 63,nid:4 }}">
                <span>自动焊专机</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'product', params: { id: 1,nid:5 }}">
                <span>产品中心</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'about', params: { id: 1,nid:6 }}">
                <span>焊机租赁</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'about', params: { id: 2,nid:7 }}">
                <span>售后服务</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'about', params: { id: 3,nid:8 }}">
                <span>公司简介</span>
              </router-link>
              <router-link tag="a" :to="{ name: 'about', params: { id: 4,nid:9 }}">
                <span>联系我们</span>
              </router-link>
        </h2>
      </div>
    </div>

    <div class="f_bg2">
      <div class="footer">
        <h3>
          <img :src="flogo" width="174" height="76" alt="威遥焊接" title="威遥焊接" />
        </h3>
        <p style="line-height:22px;">
          <span style="color:#ffffff;font-size:16px;">上海威遥焊接器材有限公司</span>&nbsp;&nbsp;
          <span style="color:#ffffff;font-size:16px;">沪 ICP 备18016133号</span>&nbsp;&nbsp;
          <span style="color:#ffffff;font-size:16px;">技术支持：</span>
          <a title="技术支持：开创广告" href="http://www.kinats.com/" target="_blank">
            <span style="color:#ffffff;font-size:16px;">开创广告</span>
          </a>
          <br />
          <span style="color:#ffffff;font-size:16px;">电话：021-65056515</span>&nbsp;&nbsp;
          <span style="color:#ffffff;font-size:16px;">传真：021-65053165</span>&nbsp;&nbsp;
          <span style="color:#ffffff;font-size:16px;">E-mail:18616336851@163.com</span>
          <br />
          <span style="color:#ffffff;font-size:16px;">地址：上海市杨浦区军工路100号20栋</span>
           <br />
          <span style="color:#ffffff;font-size:16px;">工厂地址：江苏省昆山市周市镇民管路25号1号楼2楼</span>
        </p>
        <b></b>
      </div>
    </div>
  </div>
</template>
<script>
import { menuapi } from "@/utils/api"; //引入api至当前文件
export default {
  data() {
    return {
      flogo: require("../../static/images/20141009171705_56419.jpg")
    };
  }
};
</script>
<style scoped>
</style>
